/**
 * Labstep
 *
 * @module components/OrganizationPlan/Show/FreeTrial
 * @desc Display organization free trial
 */

import { OrganizationPlanCardFreeTrial } from 'labstep-web/components/OrganizationPlan/Card/FreeTrial';
import { OrganizationPlanCardWorkspaces } from 'labstep-web/components/OrganizationPlan/Card/Workspaces';
import type React from 'react';
import OrganizationPlanCardUsers from '../../Card/Users';
import styles from './styles.module.scss';
import type { OrganizationPlanShowFreeTrialProps } from './types';

export const OrganizationPlanShowFreeTrial: React.FC<
  OrganizationPlanShowFreeTrialProps
> = ({ organization }) => (
  <div className={styles.container}>
    <OrganizationPlanCardFreeTrial organization={organization} />
    <OrganizationPlanCardUsers organization={organization} />
    <OrganizationPlanCardWorkspaces organization={organization} />
  </div>
);
